import { t } from '@lingui/core/macro';
import { Box } from '@pocketlaw/tetris';
import { TextField } from 'shared/domains/forms';
export function NameField() {
    return (<Box flexDirection="column">
      <TextField name="name" label={t({ message: 'Name', comment: 'Edit project dialog - Name input label' })} placeholder={t({
            message: 'Project name...',
            comment: 'Edit project dialog - Name input placeholder',
        })}/>
    </Box>);
}
